import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, HostBinding, Directive, ContentChildren, NgModule } from '@angular/core';
import * as i1 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { StageBaseDirective, StageBaseComponent, dialogAnimations, StageGroupBaseComponent, DmcCoreModule } from '@dmc/ng-components/core';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';

class DialogHeroComponent {
    constructor() {
        this.danger = false;
        this.icon = 'check_circle_outline';
    }
}
DialogHeroComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.0", ngImport: i0, type: DialogHeroComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DialogHeroComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.0", type: DialogHeroComponent, selector: "dmc-dialog-hero", inputs: { danger: "danger", icon: "icon" }, host: { properties: { "class.dmc-dialog-hero--danger": "this.danger" } }, ngImport: i0, template: "<mat-icon>{{ icon }}</mat-icon>\n", styles: [":host{display:flex;justify-content:center;align-items:center;min-height:150px;width:100%;padding:24px;margin:-24px -24px 24px}:host mat-icon{width:128px;height:128px;font-size:128px}"], components: [{ type: i1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.0", ngImport: i0, type: DialogHeroComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'dmc-dialog-hero',
                    templateUrl: './dialog-hero.component.html',
                    styleUrls: ['./dialog-hero.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { danger: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.dmc-dialog-hero--danger']
            }], icon: [{
                type: Input
            }] } });

class DialogStageDirective extends StageBaseDirective {
    constructor(template) {
        super(template);
    }
    // This input needs to match the directive exactly, so keeping this for clarity?
    // eslint-disable-next-line @angular-eslint/no-input-rename
    set dmcDialogStage(name) {
        this.name = name;
    }
}
DialogStageDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.0", ngImport: i0, type: DialogStageDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
DialogStageDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.0.0", type: DialogStageDirective, selector: "[dmcDialogStage]", inputs: { dmcDialogStage: "dmcDialogStage" }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.0", ngImport: i0, type: DialogStageDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[dmcDialogStage]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { dmcDialogStage: [{
                type: Input,
                args: ['dmcDialogStage']
            }] } });

class DialogStageComponent extends StageBaseComponent {
}
DialogStageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.0", ngImport: i0, type: DialogStageComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
DialogStageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.0", type: DialogStageComponent, selector: "dmc-dialog-stage", usesInheritance: true, ngImport: i0, template: "<div @animationSink *ngIf=\"currentIndex === index\">\n  <ng-template [ngTemplateOutlet]=\"template\"></ng-template>\n</div>\n", styles: [":host{display:flex;justify-content:center;align-items:center}div{width:100%;height:100%}"], directives: [{ type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], animations: dialogAnimations, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.0", ngImport: i0, type: DialogStageComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'dmc-dialog-stage',
                    templateUrl: './dialog-stage.component.html',
                    styleUrls: ['./dialog-stage.component.scss'],
                    animations: dialogAnimations,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }] });

/**
 * WARNING: Deprecated - use `<dmc-stage-group useage="modal"></dmc-stage-group>` from  '@dmc/ng-components/stage' instead
 *
 * DMC - Dialog Stage Group
 *
 * A container for different "stages" of a modal, that are animated between based on the key passed in
 *
 * @deprecated - use `<dmc-stage-group useage="modal"></dmc-stage-group>` from  '@dmc/ng-components/stage' instead.
 */
class DialogStageGroupComponent extends StageGroupBaseComponent {
    constructor() {
        super(...arguments);
        this.multistageDialogClass = true;
    }
    set _stages(stages) {
        this.stages = stages;
    }
}
DialogStageGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.0", ngImport: i0, type: DialogStageGroupComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
DialogStageGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.0.0", type: DialogStageGroupComponent, selector: "dmc-dialog-stage-group", host: { properties: { "class.multistage-dialog": "this.multistageDialogClass" } }, queries: [{ propertyName: "_stages", predicate: DialogStageDirective }], usesInheritance: true, ngImport: i0, template: "<dmc-dialog-stage\n  *ngFor=\"let s of stages; let i = index\"\n  #stageWrapper\n  [currentIndex]=\"_selectedIndex\"\n  [index]=\"i\"\n  [template]=\"s.template\"\n  (afterStageEnter)=\"afterStageChange.emit()\"\n>\n</dmc-dialog-stage>\n", styles: [":host{border-radius:4px;position:relative;display:flex;overflow:hidden;margin:-24px}:host,:host>*{box-sizing:border-box}:host>*{width:100%;flex-shrink:0;padding:24px;position:absolute;top:0;right:0;left:0;bottom:0}:host>.active{position:relative;z-index:1}"], components: [{ type: DialogStageComponent, selector: "dmc-dialog-stage" }], directives: [{ type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], animations: dialogAnimations, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.0", ngImport: i0, type: DialogStageGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'dmc-dialog-stage-group',
                    templateUrl: './dialog-stage-group.component.html',
                    styleUrls: ['./dialog-stage-group.component.scss'],
                    animations: dialogAnimations,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { multistageDialogClass: [{
                type: HostBinding,
                args: ['class.multistage-dialog']
            }], _stages: [{
                type: ContentChildren,
                args: [DialogStageDirective]
            }] } });

const PublicComponents = [DialogStageGroupComponent, DialogHeroComponent];
const PublicDirectives = [DialogStageDirective];
class DmcDialogModule {
}
DmcDialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.0", ngImport: i0, type: DmcDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DmcDialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.0.0", ngImport: i0, type: DmcDialogModule, declarations: [DialogStageComponent, DialogStageGroupComponent, DialogHeroComponent, DialogStageDirective], imports: [CommonModule, MatIconModule, DmcCoreModule], exports: [DialogStageGroupComponent, DialogHeroComponent, DialogStageDirective] });
DmcDialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.0.0", ngImport: i0, type: DmcDialogModule, imports: [[CommonModule, MatIconModule, DmcCoreModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.0", ngImport: i0, type: DmcDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DialogStageComponent,
                        ...PublicComponents,
                        ...PublicDirectives,
                    ],
                    imports: [CommonModule, MatIconModule, DmcCoreModule],
                    exports: [...PublicComponents, ...PublicDirectives],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DialogHeroComponent, DialogStageDirective, DialogStageGroupComponent, DmcDialogModule };
